// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__31sYG","errorLogs":"styles_errorLogs__1Kxc6"};